"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deployment = exports.chatQueueMapping = exports.openingHours = exports.SESSION_STORAGE_CLICKED_BUBBLE = void 0;
exports.SESSION_STORAGE_CLICKED_BUBBLE = 'has-clicked-bubble';
exports.openingHours = {
    fridayStart: '08:00',
    fridayEnd: '15:00',
    mondayToThursdayStart: '08:00',
    mondayToThursdayEnd: '16:00',
};
exports.chatQueueMapping = {
    YS_Chat_Regning: '2c2a0e96-1066-4d4d-ae8b-ebeed10c61e5',
    YS_Chat_Mix: '1c9008f0-19a4-460f-a81c-ceb18cab537d',
    YS_Chat_Kundeservice: '9479ec89-e19a-44f6-aac5-b6eee20322d0',
    YS_Chat_Support: '1fc991c6-3dc2-4812-9064-844f22d3f3f0',
    YS_Chat_Salg: '3439f39e-edf3-4bab-8c4d-ecf7d5fb7d62',
    YS_Chat_Support_Mail: 'ba00f136-be3b-4c7d-88e0-19779f52e8ba',
    YS_Chat_Support_YSR2000: '6a36ce26-23f9-4dfa-86c4-c7d0e57252db',
    DEV_YS_Chat_Mix: '896108ee-1f97-4e72-96a1-2585d9f28750',
};
exports.deployment = {
    PRODUCTION: 'eb50cf03-f634-4688-9f83-c45b31397fa6',
    STAGING: '42a029f1-0388-460b-b458-6aede8da7bfc',
    TESTBOT: '924487e3-d465-46fa-bc51-c4328d348d5e',
};
//# sourceMappingURL=constants.js.map